<template>
  <div>
    <!-- 桌面导航 -->
    <v-container
      class="py-0 navbar"
    >
      <v-row
        align="stretch"
        no-gutters
        class="grey--text text--darken-4"
      >
        <v-col
          cols="auto"
          class="py-0"
        >
          <div
            class="d-flex align-center text-h4 cursor-pointer position-relative py-2 px-4 cate-trigger"
            style="width:239px;background-color:#f5f5f5"
            @mouseover="!$route.meta.hideCatePopup ? cateTrigger = true : ''"
            @mouseleave="cateTrigger = false"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              فئة المنتج
            </template>
            <template v-else>
              Product category
            </template>
            <v-spacer />
            <v-icon
              size="24px"
              color="#333"
            >
              mdi-chevron-down
            </v-icon>
            <v-slide-y-reverse-transition>
              <v-card
                v-if="cateTrigger"
                elevation="1"
                tile
                class="cate-popup"
              >
                <v-list
                  v-if="categories.status && categories.data.length"
                  dense
                >
                  <v-list-item-group v-model="cate">
                    <v-list-item
                      v-for="item in categories.data"
                      :key="item.id"
                      class="pe-3 position-relative"
                      @mouseover="item.trigger = true;$forceUpdate()"
                      @mouseleave="item.trigger = false;$forceUpdate()"
                    >
                      <v-list-item-content @click="navigateToGoodsList(item)">
                        <v-list-item-title>{{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon v-if="item.son">
                        <v-icon
                          color="grey"
                          size="18px"
                        >
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-icon>
                      <v-scroll-x-reverse-transition>
                        <v-card
                          v-if="item.son && item.trigger"
                          elevation="1"
                          tile
                          class="cate-sub-popup"
                          :style="$vuetify.rtl ? 'right:100%' : 'left: 100%'"
                        >
                          <v-list>
                            <v-list-item-group>
                              <v-list-item
                                v-for="subitem in item.son"
                                :key="subitem.id"
                                @click="navigateToGoodsList(subitem)"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>{{ $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-card>
                      </v-scroll-x-reverse-transition>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card-text
                  v-else
                  class="text-capitalize"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    لا يوجد شيء هنا
                  </template>
                  <template v-else>
                    There is nothing here
                  </template>
                </v-card-text>
              </v-card>
            </v-slide-y-reverse-transition>
          </div>
        </v-col>
        <v-divider vertical />
        <v-row
          no-gutters
          align="stretch"
          justify="space-between"
        >
          <v-col
            v-for="(item, i) in navs"
            :key="i"
            cols="auto"
          >
            <router-link
              class="px-8 text-h6"
              :class="navIndex === i ? 'active' : ''"
              :to="item.url"
              exact
            >
              {{ $store.getters.languageGetter === '1' ? item.name : item.nameEn }}
            </router-link>
          </v-col>
          <v-spacer />
          <v-col
            cols="auto"
            align-self="center"
          >
            <v-menu
              offset-y
              open-on-hover
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  rounded
                  color="#111f5e"
                  elevation="0"
                  class="d-flex align-center"
                  v-bind="attrs"
                  v-on="on"
                >
                  Country
                  <v-spacer class="mx-4" />
                  <v-icon
                    small
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in $store.state.webConfig.countryList"
                  :key="i"
                  class="pe-1"
                  @click="setUsedCountry(item)"
                >
                  <v-list-item-title class="d-flex align-center">
                    {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                  </v-list-item-title>
                  <v-list-item-action v-if="$store.getters.countryGetter && item.id === $store.getters.countryGetter.id">
                    <v-icon small>
                      mdi-check
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
    <v-divider />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'NavbarDesktop',
  data() {
    return {
      cateTrigger: false,
      cate: '',
      navIndex: 0,
      navs: [
        {
          name: 'الصفحة الرئيسية',
          nameEn: 'Home',
          url: { name: 'Home' },
        },
        {
          name: 'معلومات عنا',
          nameEn: 'About Us',
          url: { name: 'AboutUs' },
        },
        {
          name: 'قائمة المنتجات',
          nameEn: 'Products',
          url: { name: 'GoodsList', query: { p: 1 } },
        },
        {
          name: 'منتج جديد',
          nameEn: 'New Arrivals',
          url: { name: 'GoodsList', query: { type: '2', target: 'newArrivals', p: 1 } },
        },
        {
          name: 'اترك رسالة',
          nameEn: 'Feedback',
          url: { name: 'Feedback' },
        },
        {
          name: 'معلومات الاتصال بالشركة',
          nameEn: 'Contact Us',
          url: { name: 'ContactUs' },
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'categories',
    ]),
  },
  watch: {
    $route(to) {
      if (to.name === 'GoodsList' && to.query.type) {
        this.setActiveNav(3);
      } else {
        this.setActiveNav(this.navs.findIndex((item) => item.url.name === to.name));
      }
    },
  },
  created() {
    if (this.$route.name === 'GoodsList' && this.$route.query.type) {
      this.setActiveNav(+this.$route.query.type);
    } else {
      const index = this.navs.findIndex((item) => this.$route.name === item.url.name);
      this.setActiveNav(index);
    }
    this.getGoodsCagegoriesAsync();
  },
  methods: {
    ...mapActions(['getGoodsCagegoriesAsync']),
    setActiveNav(index) {
      this.navIndex = index;
    },
    navigateToGoodsList(item) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      this.$router.push({
        name: 'GoodsList',
        query: {
          categoryId: item.id,
          categoryName: item.dnames,
          p: 1,
        },
      });
    },
    setUsedCountry(country) {
      if (country.id) {
        localStorage.setItem('country', country.id);
      } else {
        localStorage.removeItem('country');
      }
      this.$store.commit('SET_USED_COUNTRY', country.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  .col {
    text-transform: uppercase;

    a {
      display: flex;
      align-items: center;
      height: 100%;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        height: 4px;
        width: 0;
        background-color: #e1c468;
        transition: all 0.3s;
      }

      &.active,
      &:hover {
        position: relative;

        &::after {
          left: 10%;
          width: 80%;
        }
      }
    }

    .active {
      font-weight: bold;
      color: #e1c468;
    }
  }

  .cate-popup {
    position: absolute;
    z-index: 1;
    top: 100%;
    right: 0;
    left: 0;
  }

  .cate-trigger {
    .cate-sub-popup {
      position: absolute;
      top: -8px;
    }
  }
}
</style>
